import { useEffect } from 'react';

/**
 * Refetch when the browser tab becomes visible again (PRD D11), reusing the
 * mechanism from `useServiceAgreementsList`: Review and the Dealer
 * verification flow open in a new tab, and global RQ defaults disable
 * `refetchOnWindowFocus`, so the list tab would otherwise stay stale after an
 * accept/decline/cancel made from another tab.
 */
export function useVisibilityRefetch(refetch: () => void): void {
  useEffect(() => {
    const refetchWhenVisible = () => {
      if (document.visibilityState === 'visible') {
        refetch();
      }
    };

    document.addEventListener('visibilitychange', refetchWhenVisible);
    return () => {
      document.removeEventListener('visibilitychange', refetchWhenVisible);
    };
  }, [refetch]);
}
